import type { CustomerAccessRepository } from '#/domain/customerAccess/CustomerAccessRepository'
import type { Customer } from '#/domain/customerAccess/Customer'
import type { Feature } from '#/domain/customerAccess/Feature'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomainList as toCustomerDomainList, type CustomerResponseDto } from './CustomerDto'
import { toDomainList as toFeatureDomainList, type FeatureResponseDto } from './FeatureDto'

export class HttpCustomerAccessRepository implements CustomerAccessRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAccessibleCustomers(): Promise<Customer[]> {
    const raw = await this.http.get<CustomerResponseDto[]>('v1/customer')
    return toCustomerDomainList(raw)
  }

  async findFeaturesForCustomer(customerId: string): Promise<Feature[]> {
    const raw = await this.http.get<FeatureResponseDto[]>(
      `v1/customer/${encodeURIComponent(customerId)}/features`,
    )
    return toFeatureDomainList(raw)
  }

  async findAllFeatures(): Promise<Feature[]> {
    const raw = await this.http.get<FeatureResponseDto[]>('v1/features')
    return toFeatureDomainList(raw)
  }

  grantFeature(customerId: string, featureId: string): Promise<void> {
    return this.http.post<void>(
      `v1/customer/${encodeURIComponent(customerId)}/features/${encodeURIComponent(featureId)}`,
    )
  }

  revokeFeature(customerId: string, featureId: string): Promise<void> {
    return this.http.delete<void>(
      `v1/customer/${encodeURIComponent(customerId)}/features/${encodeURIComponent(featureId)}`,
    )
  }
}
